/* eslint-disable */
export default {

	init() {
		// JavaScript to be fired on the home page
		$('.match-height').matchHeight()
		setInterval(() => {
			$('.match-height').matchHeight()
		}, 1000);
	},
	finalize() {

		var customSlider = $('.custom-slider');

		customSlider.not('.slick-initialized').slick({
			prevArrow: '<svg class="slick-prev" width="64" height="64" viewBox="0 0 64 64"> <g id="Groupe_902" data-name="Groupe 902" transform="translate(-60 -2881)"> <g id="left-arrow" transform="translate(17 22)" opacity="1"> <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(43 2859)" fill="none" stroke="#fff" stroke-width="2"> <circle cx="32" cy="32" r="32" stroke="none"/> <circle cx="32" cy="32" r="31" fill="none"/> </g> <g id="Groupe_11" data-name="Groupe 11" transform="translate(59 2875)"> <rect id="Rectangle_13" data-name="Rectangle 13" width="32" height="32" fill="#fff" opacity="0"/> <g id="Groupe_10" data-name="Groupe 10" transform="translate(9.666 6.666)"> <path id="Tracé_6" data-name="Tracé 6" d="M17.333,23.667a1.33,1.33,0,0,1-.943-.391l-8-8a1.332,1.332,0,0,1,0-1.885l8-8a1.333,1.333,0,0,1,1.885,1.885l-7.057,7.057,7.057,7.057a1.333,1.333,0,0,1-.943,2.276Z" transform="translate(-8 -5)" fill="#fff"/> </g> </g> </g> </g></svg>',
			nextArrow: '<svg class="slick-next" width="64" height="64" viewBox="0 0 64 64"> <g id="Groupe_903" data-name="Groupe 903" transform="translate(-1796 -2881)"> <g id="right-arrow" transform="translate(1903 5804) rotate(180)" opacity="1"> <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(43 2859)" fill="none" stroke="#fff" stroke-width="2"> <circle cx="32" cy="32" r="32" stroke="none"/> <circle cx="32" cy="32" r="31" fill="none"/> </g> <g id="Groupe_11" data-name="Groupe 11" transform="translate(59 2875)"> <rect id="Rectangle_13" data-name="Rectangle 13" width="32" height="32" fill="#fff" opacity="0"/> <g id="Groupe_10" data-name="Groupe 10" transform="translate(9.666 6.666)"> <path id="Tracé_6" data-name="Tracé 6" d="M17.333,23.667a1.33,1.33,0,0,1-.943-.391l-8-8a1.332,1.332,0,0,1,0-1.885l8-8a1.333,1.333,0,0,1,1.885,1.885l-7.057,7.057,7.057,7.057a1.333,1.333,0,0,1-.943,2.276Z" transform="translate(-8 -5)" fill="#fff"/> </g> </g> </g> </g></svg>',
			arrows: true,
			infinite: true,
			speed: 800,
			slidesToShow: 1,
			adaptiveHeight: false,
			adaptiveWidth: false,
		})

		// $('[data-fancybox]').fancybox({
		//   afterShow: function(fb, item){
		//     var content = fb.$refs.stage.find('.fancybox-content');
		//     content.append(fb.$refs.caption); // move caption
		//   }
		// });

		// $('a:not(.nav-item)').on('click', function() {

		//   // Make sure this.hash has a value before overriding default behavior
		//   if (this.hash !== '') {

		//     // Store hash
		//     var hash = this.hash;

		//     if(  $('.submenu-pages').hasClass('active')) {
		//       $('.submenu-pages').removeClass('active')
		//       $('.submenu_link_pages ').removeClass('submenu_link_pages-open')

		//       if (document.querySelector('header').style.maxHeight === 'max-content')
		//         { setTimeout(function () {
		//           document.querySelector('header').style.maxHeight = ''
		//         }, 400) }
		//       else {
		//         document.querySelector('header').style.maxHeight = 'max-content'
		//       }
		//     }

		//     // Using jQuery's animate() method to add smooth page scroll
		//     // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
		//     $('html, body').animate({
		//       scrollTop: $(hash).offset().top
		//     }, 2000, function() {

		//       // Add hash (#) to URL when done scrolling (default click behavior)
		//       window.location.hash = hash;
		//     });
		//     return false;
		//   } // End if
		// });

		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		})

		setTimeout(function () {
			$('.header-slider').not('.slick-initialized').slick({
				prevArrow: '<svg class="slick-prev" width="64" height="64" viewBox="0 0 64 64"> <g id="Groupe_902" data-name="Groupe 902" transform="translate(-60 -2881)"> <g id="left-arrow" transform="translate(17 22)" opacity="1"> <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(43 2859)" fill="none" stroke="#fff" stroke-width="2"> <circle cx="32" cy="32" r="32" stroke="none"/> <circle cx="32" cy="32" r="31" fill="none"/> </g> <g id="Groupe_11" data-name="Groupe 11" transform="translate(59 2875)"> <rect id="Rectangle_13" data-name="Rectangle 13" width="32" height="32" fill="#fff" opacity="0"/> <g id="Groupe_10" data-name="Groupe 10" transform="translate(9.666 6.666)"> <path id="Tracé_6" data-name="Tracé 6" d="M17.333,23.667a1.33,1.33,0,0,1-.943-.391l-8-8a1.332,1.332,0,0,1,0-1.885l8-8a1.333,1.333,0,0,1,1.885,1.885l-7.057,7.057,7.057,7.057a1.333,1.333,0,0,1-.943,2.276Z" transform="translate(-8 -5)" fill="#fff"/> </g> </g> </g> </g></svg>',
				nextArrow: '<svg class="slick-next" width="64" height="64" viewBox="0 0 64 64"> <g id="Groupe_903" data-name="Groupe 903" transform="translate(-1796 -2881)"> <g id="right-arrow" transform="translate(1903 5804) rotate(180)" opacity="1"> <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(43 2859)" fill="none" stroke="#fff" stroke-width="2"> <circle cx="32" cy="32" r="32" stroke="none"/> <circle cx="32" cy="32" r="31" fill="none"/> </g> <g id="Groupe_11" data-name="Groupe 11" transform="translate(59 2875)"> <rect id="Rectangle_13" data-name="Rectangle 13" width="32" height="32" fill="#fff" opacity="0"/> <g id="Groupe_10" data-name="Groupe 10" transform="translate(9.666 6.666)"> <path id="Tracé_6" data-name="Tracé 6" d="M17.333,23.667a1.33,1.33,0,0,1-.943-.391l-8-8a1.332,1.332,0,0,1,0-1.885l8-8a1.333,1.333,0,0,1,1.885,1.885l-7.057,7.057,7.057,7.057a1.333,1.333,0,0,1-.943,2.276Z" transform="translate(-8 -5)" fill="#fff"/> </g> </g> </g> </g></svg>',
				arrows: true,
				infinite: true,
				speed: 800,
				slidesToShow: 1,
				adaptiveHeight: false,
				adaptiveWidth: false,
			})
		}, 1000);

		var slider = $('.product-slider-container')
		var elements = document.querySelectorAll('.btn--plus')
		var loop = function () {
			var element = list[i];

			element.onclick = function (e) {
				e.preventDefault()
				element.classList.toggle('btn--plus-open')
			}
		};

		for (var i = 0, list = elements; i < list.length; i += 1) loop();

		slider.not('.slick-initialized').slick({
			dots: false,
			infinite: true,
			speed: 600,
			slidesToShow: 1,
			variableWidth: true,
			centerMode: true,
			prevArrow: '<svg class="slick-prev" width="64" height="64" viewBox="0 0 64 64"> <g id="Groupe_902" data-name="Groupe 902" transform="translate(-60 -2881)"> <g id="left-arrow" transform="translate(17 22)" opacity="1"> <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(43 2859)" fill="none" stroke="#fff" stroke-width="2"> <circle cx="32" cy="32" r="32" stroke="none"/> <circle cx="32" cy="32" r="31" fill="none"/> </g> <g id="Groupe_11" data-name="Groupe 11" transform="translate(59 2875)"> <rect id="Rectangle_13" data-name="Rectangle 13" width="32" height="32" fill="#fff" opacity="0"/> <g id="Groupe_10" data-name="Groupe 10" transform="translate(9.666 6.666)"> <path id="Tracé_6" data-name="Tracé 6" d="M17.333,23.667a1.33,1.33,0,0,1-.943-.391l-8-8a1.332,1.332,0,0,1,0-1.885l8-8a1.333,1.333,0,0,1,1.885,1.885l-7.057,7.057,7.057,7.057a1.333,1.333,0,0,1-.943,2.276Z" transform="translate(-8 -5)" fill="#fff"/> </g> </g> </g> </g></svg>',
			nextArrow: '<svg class="slick-next" width="64" height="64" viewBox="0 0 64 64"> <g id="Groupe_903" data-name="Groupe 903" transform="translate(-1796 -2881)"> <g id="right-arrow" transform="translate(1903 5804) rotate(180)" opacity="1"> <g id="Ellipse_2" data-name="Ellipse 2" transform="translate(43 2859)" fill="none" stroke="#fff" stroke-width="2"> <circle cx="32" cy="32" r="32" stroke="none"/> <circle cx="32" cy="32" r="31" fill="none"/> </g> <g id="Groupe_11" data-name="Groupe 11" transform="translate(59 2875)"> <rect id="Rectangle_13" data-name="Rectangle 13" width="32" height="32" fill="#fff" opacity="0"/> <g id="Groupe_10" data-name="Groupe 10" transform="translate(9.666 6.666)"> <path id="Tracé_6" data-name="Tracé 6" d="M17.333,23.667a1.33,1.33,0,0,1-.943-.391l-8-8a1.332,1.332,0,0,1,0-1.885l8-8a1.333,1.333,0,0,1,1.885,1.885l-7.057,7.057,7.057,7.057a1.333,1.333,0,0,1-.943,2.276Z" transform="translate(-8 -5)" fill="#fff"/> </g> </g> </g> </g></svg>',

			responsive: [
				{
					breakpoint: 991,
					settings: {
						arrows: false,
						centerPadding: '90px',
					}
				}]
		})

		var os = getOS();
		var osFile;

		if (os === 'Mac OS') {
			osFile = 'jardivision-osx.dmg'
		} else {
			osFile = 'jardivision-win.zip'
		}

		$('.jardivisionDownload').attr('href', window.uploadDir + '/' + osFile)

		setTimeout(function () {
			resizeBlock()
		}, 100)

		window.onresize = function () {
			if (block_media) {
				resizeBlock()
			}
		}


		// // Main menu
		var submenuLinks = document.querySelectorAll('header [class*="submenu_link"]');
		var submenus = document.querySelectorAll('#wrapper-submenu [class*="submenu-"]');
		var backgroundHeader = document.querySelector('header .background-header');
		var mainMenu = document.getElementById('primary');
		var submenuWrapper = document.getElementById('wrapper-submenu');
		submenuLinks.forEach(function (submenuLink) {
			submenuLink.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				var submenuLinkClicked = this;
				var submenuTarget;

				// Target
				if (this.classList.contains('menu-produits')) {
					submenuTarget = document.querySelector('#wrapper-submenu .submenu-product');
				} else if (this.classList.contains('menu-la-societe')) {
					submenuTarget = document.querySelector('#wrapper-submenu .submenu-pages');
				} else if (this.classList.contains('menu-actualites')) {
					submenuTarget = document.querySelector('#wrapper-submenu .submenu-actu');
				} else if (this.classList.contains('submenu_link_search')) {
					submenuTarget = document.querySelector('#wrapper-submenu .submenu-search');
				}


				// Reset
				submenus.forEach(function (submenu) {
					if (submenu.classList.contains('active') && submenu != submenuTarget) {
						submenu.classList.remove('active');
					}
				});
				submenuLinks.forEach(function (submenuLink) {
					if (submenuLink.classList.contains('active') && submenuLink != submenuLinkClicked) {
						submenuLink.classList.remove('active');
					}
				});

				// Open / close (submenulink)
				if (!submenuLink.classList.contains('active') || submenuLink.classList.contains('active') && !submenuWrapper.classList.contains('active')) {

					document.querySelector('.sub-menu.active') && document.querySelector('.sub-menu.active').classList.remove('active');
					document.querySelector('.menu-item-has-children.open') && document.querySelector('.menu-item-has-children.open').classList.remove('open');

					submenuLink.classList.add('active');
				} else {
					console.log('test2')
					submenuLink.classList.remove('active');
				}

				// Open / close (submenu)
				if (!submenuTarget.classList.contains('active')) {
					submenuTarget.classList.add('active');
					if (window.matchMedia("(min-width: 1520px)").matches) {
						backgroundHeader.classList.add('active');
						if ($('header').hasClass('black')) {
							$('header').addClass('white');
							document.querySelector('.logoScrolled').classList.remove('d-none')
							document.querySelector('.logoScrolled').classList.add('d-block')
							document.querySelector('.logoUnscrolled').classList.remove('d-block')
							document.querySelector('.logoUnscrolled').classList.add('d-none')
						}
					}

					if (window.matchMedia("(max-width: 1520px)").matches) {
						submenuTarget.parentNode.classList.add('active');
						mainMenu.classList.add('disable');
					}
				} else {
					submenuTarget.classList.remove('active');
					backgroundHeader.classList.remove('active');

					if ($('header').hasClass('black')) {
						$('header').removeClass('white');
					}

					if ($('header').hasClass('black') && !$('header').hasClass('scrolled')) {
						$('header').removeClass('white');
						document.querySelector('.logoScrolled').classList.add('d-none')
						document.querySelector('.logoScrolled').classList.remove('d-block')
						document.querySelector('.logoUnscrolled').classList.remove('d-none')
						document.querySelector('.logoUnscrolled').classList.add('d-block')
					}

					if (window.matchMedia("(max-width: 1520px)").matches) {
						submenuTarget.parentNode.classList.remove('active');
						mainMenu.classList.remove('disable');
					}
				}
			});
		});


		var burger = document.querySelector('.burger');
		var menuMobile = document.querySelector('header .menu-left .nav-primary');
		burger.addEventListener('click', function (e) {
			e.preventDefault();
			var activeSubmenu = document.querySelector('#wrapper-submenu .active');
			if (!burger.classList.contains('active')) {
				burger.classList.add('active');
				if (activeSubmenu) {
					submenuWrapper.classList.add('active');
				}
			} else {
				burger.classList.remove('active');
				if (submenuWrapper.classList.contains('active')) {
					submenuWrapper.classList.remove('active');
				}
			}

			if (!menuMobile.classList.contains('active')) {
				menuMobile.classList.add('active');
			} else {
				menuMobile.classList.remove('active');
			}
		});

		var backMenu = document.querySelectorAll('.nav-mobile .return');
		backMenu.forEach(function (button) {
			button.addEventListener('click', function (e) {
				e.preventDefault();
				const activeWpSubmenu = document.querySelector('.sub-menu.active');
				if (activeWpSubmenu) {
					activeWpSubmenu.classList.remove('active');
				}
				const navsDomElement = document.querySelector('.navs');
				navsDomElement.classList.remove('addOverlay');
				button.classList.remove('active')
				// var activeSubmenu = document.querySelector('#wrapper-submenu .active');
				// var submenuLinkActive = document.querySelector('header [class*="submenu_link"].active');
				// if (activeSubmenu) {
				// 	if (submenuLinkActive) {
				// 		submenuLinkActive.classList.remove('active');
				// 	}
				// 	mainMenu.classList.remove('disable');
				// 	submenuWrapper.classList.remove('active');
				// 	activeSubmenu.classList.remove('active');
				// } else {
				// 	menuMobile.classList.remove('active');
				// 	burger.classList.remove('active');
				// }
			});
		});

		var searchMenu = document.querySelectorAll('.nav-mobile .search');
		var searchSubmenu = document.querySelector('.submenu-search');
		searchMenu.forEach(function (button) {
			button.addEventListener('click', function (e) {
				e.preventDefault();
				// var activeSubmenu = document.querySelector('#wrapper-submenu .active');
				// if (activeSubmenu) {
				// 	activeSubmenu.classList.remove('active');
				// }
				const activeWpSubmenu = document.querySelector('.sub-menu.active');
				if (activeWpSubmenu) {
					console.log('ahahahahahah')
					activeWpSubmenu.classList.remove('active');
				}
				submenuWrapper.classList.add('active');
				searchSubmenu.classList.add('active');
				// const returnBtn = document.querySelector('.nav-primary .nav-mobile .return');
				// returnBtn && returnBtn.classList.add('active');
			});
		});

		var closeMenu = document.querySelectorAll('.close-mobile');
		closeMenu.forEach(function (button) {
			button.addEventListener('click', function (e) {
				var activeSubmenu = document.querySelector('#wrapper-submenu .active');
				const activeWpSubmenu = document.querySelector('.sub-menu.active');
				if (activeWpSubmenu) {
					activeWpSubmenu.classList.remove('active');
					const activeWpSubmenuParent = activeWpSubmenu.parentElement;
					if (activeWpSubmenuParent) {
						activeWpSubmenuParent.classList.remove('open');
					}
				}
				const overlayMobile = document.querySelector('.navs.addOverlay');
				overlayMobile && overlayMobile.classList.remove('addOverlay');

				const returnBtn = document.querySelector('.nav-primary .nav-mobile .return');
				returnBtn && returnBtn.classList.remove('active');
				var submenuLinkActive = document.querySelector('header [class*="submenu_link"].active');
				if (submenuLinkActive) {
					submenuLinkActive.classList.remove('active');
				}
				if (activeSubmenu) {
					activeSubmenu.classList.remove('active');
				}
				const isWrapperActive = document.querySelector('#wrapper-submenu.active')
				isWrapperActive && isWrapperActive.classList.remove('active');
				// submenuWrapper.classList.remove('active');
				burger.classList.remove('active');
				menuMobile.classList.remove('active');
				mainMenu.classList.remove('disable');
			});
		});


		window.onscroll = function () {
			scrollFunction();
			closeMainMenu();
		}

		function closeMainMenu() {
			if (window.matchMedia("(min-width: 1521px)").matches) {
				submenus.forEach(function (submenu) {
					if (submenu.classList.contains('active')) {
						submenu.classList.remove('active');
					}
				});
				submenuLinks.forEach(function (submenuLink) {
					if (submenuLink.classList.contains('active')) {
						submenuLink.classList.remove('active');
					}
				});
			}
		}

		// function closeMenuOnClickOut() {
		// 	document.addEventListener('click', function (event) {
		// 		var clickOnMenu = false;
		//
		// 		event.path.forEach(function (item) {
		// 			if (item.id === 'wrapper-submenu') {
		// 				clickOnMenu = true;
		// 			}
		// 		});
		//
		// 		if (!clickOnMenu && menuIsOpen()) {
		// 			closeMainMenu();
		// 		}
		// 	});
		// }

		// closeMenuOnClickOut();

		function menuIsOpen() {
			if (backgroundHeader.classList.contains('active')) {
				return true;
			}

			return false;
		}


		var block_media = document.querySelectorAll('.section-block')
		var header = document.querySelector('header')

		function getOS() {
			var userAgent = window.navigator.userAgent,
				platform = window.navigator.platform,
				macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
				windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
				iosPlatforms = ['iPhone', 'iPad', 'iPod'],
				os = null;

			if (macosPlatforms.indexOf(platform) !== -1) {
				os = 'Mac OS';
			} else if (iosPlatforms.indexOf(platform) !== -1) {
				os = 'iOS';
			} else if (windowsPlatforms.indexOf(platform) !== -1) {
				os = 'Windows';
			} else if (/Android/.test(userAgent)) {
				os = 'Android';
			} else if (!os && /Linux/.test(platform)) {
				os = 'Linux';
			}
			return os;
		}

		function scrollFunction() {
			var menu_open = header.querySelector('.submenu_link-open')
			if (window.pageYOffset > header.offsetTop) {
				header.classList.add('scrolled')
				document.querySelector('.background-header').classList.remove('active')
				document.querySelector('.logoScrolled').classList.remove('d-none')
				document.querySelector('.logoScrolled').classList.add('d-block')
				document.querySelector('.logoUnscrolled').classList.remove('d-block')
				document.querySelector('.logoUnscrolled').classList.add('d-none')

			} else if (!menu_open) {
				header.classList.remove('scrolled')
				const isSubmenuActive = header.querySelector('.sub-menu.active')

				isSubmenuActive && isSubmenuActive.classList.remove('active');
				const isMenuItemOpen = header.querySelector('.menu-item-has-children.open');
				isMenuItemOpen && isMenuItemOpen.classList.remove('open');
				if (!$('.background-header').hasClass('active')) {
					if ($('.header').hasClass('black')) {
						$('header').removeClass('white');
					}
					document.querySelector('.logoScrolled').classList.add('d-none')
					document.querySelector('.logoScrolled').classList.remove('d-block')
					document.querySelector('.logoUnscrolled').classList.remove('d-none')
					document.querySelector('.logoUnscrolled').classList.add('d-block')
				}
			}
		}

		function resizeBlock() {
			if (block_media) {
				for (var i = 0, list = block_media; i < list.length; i += 1) {
					var block = list[i];
					var img_size = block.querySelector('img')
					if (img_size) {
						block.querySelector('.row').style.minHeight = img_size.height + 'px'
					}
				}
			}
		}


		class App {
			constructor() {
				this.header = document.querySelector('header.banner');
				this.return = this.header.querySelector('.nav-primary .nav-mobile .return')
				this.backgroundHeader = this.header.querySelector('.background-header')
				this.handleEvents()
			}

			handleEvents() {
				document.addEventListener('click', (e) => {
					!e.target.closest('.menu-item-has-children') && this.reset()
					e.target.closest('.menu-item-has-children') && this.toggleSubmenu(e.target)
					e.target.classList.contains('.submenu_link_search') && console.log('clicked')
				})
			}

			toggleSubmenu(target) {

				const navsDomElement = header.querySelector('.navs');
				const submenu = target.parentNode.querySelector('.sub-menu');
				const parent = target.parentNode

				if (parent.classList.contains('open')) {
					parent.classList.remove('open');
					navsDomElement.classList.remove('addOverlay')
					submenu.classList.remove('active')
					this.return.classList.remove('active')
					this.backgroundHeader.classList.remove('active')
				} else {
					header.querySelector('.menu-item-has-children.open') && header.querySelector('.menu-item-has-children.open').classList.remove('open');
					header.querySelector('.sub-menu.active') && header.querySelector('.sub-menu.active').classList.remove('active');
					parent.classList.add('open');
					navsDomElement.classList.add('addOverlay')
					submenu.classList.add('active')
					this.return.classList.add('active')
					this.backgroundHeader.classList.add('active')
				}

				// submenu.classList.toggle('active');

				// navsDomElement.classList.toggle('addOverlay');
				// parent.classList.toggle('open');
				// this.return.classList.add('active')
				// if (window.scrollY === 0) {
				// 	this.backgroundHeader.classList.toggle('active')
				// }

				const getActiveSearch = this.header.querySelector('.row.submenu-search.active');
				if (getActiveSearch) {
					getActiveSearch.classList.remove('active');
					this.backgroundHeader.classList.add('active');
				}
			}

			reset() {
				if (window.matchMedia("(min-width: 1521px)").matches) {
					header.querySelector('.menu-item-has-children.open') && header.querySelector('.menu-item-has-children.open').classList.remove('open');
					header.querySelector('.sub-menu.active') && header.querySelector('.sub-menu.active').classList.remove('active');
					header.querySelector('.navs') && header.querySelector('.navs').classList.remove('addOverlay');
					backgroundHeader.classList.remove('active');
					searchSubmenu.classList.remove('active');
				}
			}
		}

		new App();

	},
}


// WEBPACK FOOTER //
// ./scripts/routes/common.js


// WEBPACK FOOTER //
// ./scripts/routes/common.js